import { combineReducers } from 'redux';

import contactReducer from './contact';
import signupReducer from './signup';
import reportReducer from './report';
import waitlistReducer from './waitlist';


export const rootReducer = combineReducers({
  contact: contactReducer,
  report: reportReducer,
  signup: signupReducer,
  waitlist: waitlistReducer,
});





// WEBPACK FOOTER //
// ./src/reducers/index.js